export function buildUrlWithBaseUrl(baseUrl: string | undefined | null, path: string) {
  if (!baseUrl) {
    return path;
  }
  const base = baseUrl.replace(/\/+$/, '');
  const segment = path.replace(/^\/+/, '');
  if (!segment) {
    return base;
  }
  return `${base}/${segment}`;
}
